import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';

const emsName = 'DPSV2FooterCopyrightDesktop';

export const CopyrightDesktop = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
